import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApi } from './auth/rest.api';

@Injectable()
export class AppDataService {

    private api_current_environment = 'api/Environment/GetCurrentEnvironment';
    public loading = true;

    constructor(private _authHttp: RestApi) { }

    getCurrentEnvironment(): Observable<any> {
        return this._authHttp.get(this.api_current_environment);
    };

    setLoader(status): void{
        this.loading = status;
    };
    isLoading(): boolean{
        return this.loading;
    }

}